<template>
  <div>
    <!-- needd this componenent to logout -->
  </div>
  
</template>
<script>
  import Vuex from 'vuex'
  export default {
    name: 'logout',
    methods: {
      ...Vuex.mapActions(['logout'])
    },
    created: function() {
      this.logout()
      this.$router.push({ path: '/beta/auth' })
    }
  }
</script>


// WEBPACK FOOTER //
// src/admin/components/Logout.vue